var _filter, _rect, _text, _text2, _g, _g2, _g3, _g4, _g5, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg12MultipleP2P(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "userGradP2p",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#4f46e5"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadowP2p",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 6,
    floodOpacity: 0.25
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 500,
    fill: "#0f172a"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 40,
    textAnchor: "middle",
    fill: "#f8fafc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 24,
    fontWeight: "bold"
  }, "\n    Problem: Multiple P2P Connections\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 65,
    textAnchor: "middle",
    fill: "#f87171",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14
  }, "\n    Each participant needs connection to every other participant\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 130)",
    filter: "url(#shadowP2p)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 40,
    fill: "url(#userGradP2p)"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "A"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(620, 200)",
    filter: "url(#shadowP2p)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 40,
    fill: "url(#userGradP2p)"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "B"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(580, 360)",
    filter: "url(#shadowP2p)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 40,
    fill: "url(#userGradP2p)"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "C"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(320, 360)",
    filter: "url(#shadowP2p)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 40,
    fill: "url(#userGradP2p)"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "D"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(280, 200)",
    filter: "url(#shadowP2p)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 40,
    fill: "url(#userGradP2p)"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "E"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 450,
    y1: 170,
    x2: 580,
    y2: 200,
    stroke: "#f87171",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 450,
    y1: 170,
    x2: 540,
    y2: 330,
    stroke: "#f87171",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 450,
    y1: 170,
    x2: 360,
    y2: 330,
    stroke: "#f87171",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 450,
    y1: 170,
    x2: 320,
    y2: 200,
    stroke: "#f87171",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 220,
    x2: 540,
    y2: 330,
    stroke: "#fbbf24",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 220,
    x2: 360,
    y2: 330,
    stroke: "#fbbf24",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 220,
    x2: 320,
    y2: 220,
    stroke: "#fbbf24",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 360,
    x2: 360,
    y2: 360,
    stroke: "#a78bfa",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 340,
    x2: 320,
    y2: 240,
    stroke: "#a78bfa",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 340,
    x2: 320,
    y2: 240,
    stroke: "#34d399",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(750, 250)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -60,
    width: 160,
    height: 120,
    rx: 12,
    fill: "#1e293b",
    stroke: "#ef4444",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    y: -30,
    textAnchor: "middle",
    fill: "#f8fafc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: "bold"
  }, "Connections Formula"), /*#__PURE__*/React.createElement("text", {
    y: 0,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontFamily: "monospace",
    fontSize: 16
  }, "n(n-1)/2"), /*#__PURE__*/React.createElement("text", {
    y: 25,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "5 users = 10 connections"), /*#__PURE__*/React.createElement("text", {
    y: 45,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "10 users = 45 connections!"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 455)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -280,
    y: -25,
    width: 560,
    height: 50,
    rx: 10,
    fill: "#7f1d1d",
    stroke: "#ef4444",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    y: 8,
    textAnchor: "middle",
    fill: "#fecaca",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#f87171",
    fontWeight: "bold"
  }, "\u26A0\uFE0F Problem:"), " High CPU/bandwidth usage \u2022 Poor performance on mobile \u2022 Not scalable for large groups\n    "))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg12MultipleP2P);
export default __webpack_public_path__ + "static/media/12-multiple-p2p.b193472b41aea5cb16d06bae7232911e.svg";
export { ForwardRef as ReactComponent };